import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9011/api'

export const getRegisterMailBox = () => {
  const url = `${API_ROOT}/dashboard/digital-mailbox`
  return doGet(url)
}

export const saveRegisterMailBox = (request) => {
  const url = `${API_ROOT}/dashboard/digital-mailbox`
  return doPost(url, request)
}
